import { REGION_TYPES } from 'shared/stores/annotations';
import us from 'uScope/js/defines';

export const redrawTool = {
  install (toolbox) {
    return toolbox.extend('redraw', {
      action () {
        this.VIEWPORT.currentViewport.navModeSwitch(us.eNavModes.nmRedrawStarting);
      },

      isEnabledDelegate () {
        const result = this.ANNOTATIONS.selectedRegion && this.ANNOTATIONS.selectedRegion.type === REGION_TYPES.PEN;
        return {and: result};
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/uScope/js/extensions/annotations/annotations-ui/tools/redraw.js